import SV from 'server-vars';

function listenWindowClose(targetWindow: Window): Promise<void> {
    return new Promise(resolve => {
        const interval = setInterval(() => {
            try {
                if (targetWindow === null || targetWindow.closed) {
                    clearInterval(interval);
                    resolve();
                }
            } catch (e) {
                resolve();
            }
        }, 500);
    });
}

function getNewBrowserWindowOptions(): string {
    const width = 665;
    const height = 500;
    const sW = screen.width;
    const sH = screen.height;

    const halfSw = sW / 2;
    const halfSh = sH / 2;
    const halfWidth = width / 2;
    const halfHeight = height / 2;

    const qps = new URLSearchParams({
        width: String(width),
        height: String(height),
        toolbar: 'no',
        resizable: 'no',
        scrollbars: 'yes',
        left: String(sW > width ? Math.round(halfSw - halfWidth) : 0),
        top: String(sH > height ? Math.round(halfSh - halfHeight) : 0),
    });
    return qps.toString();
}

type PinPayload = {
    newBrowserWindow?: boolean;
    description: string;
    media: string;
    url: string;
};

export function pin(payload: PinPayload): void {
    const { newBrowserWindow, description, media, url } = payload || {};
    const options = newBrowserWindow === true ? getNewBrowserWindowOptions() : void 0;
    const pinterestWindow = window.open('', 'pinterest', options);
    if (pinterestWindow) {
        pinterestWindow.location.href = `https://pinterest.com/pin/create/button/?url=${url}&media=${media}&description=${description}`;
        listenWindowClose(pinterestWindow);
    }
}

type FacebookSharePayload = {
    newBrowserWindow?: boolean;
};

export function facebookShare(payload: FacebookSharePayload): void {
    const { newBrowserWindow } = payload || {};
    const options = newBrowserWindow === true ? getNewBrowserWindowOptions() : void 0;
    const facebookWindow = window.open('', 'facebook', options);
    const url = `http://www.facebook.com/sharer.php?app_id=${SV.get('config.facebookAppId')}&u=${
        location.href
    }`;
    if (facebookWindow) {
        facebookWindow.location.href = url;
        listenWindowClose(facebookWindow);
    }
}
type TwitterSharePayload = {
    newBrowserWindow?: boolean;
    text: string;
    url: string;
};

export function twitterShare(payload: TwitterSharePayload): void {
    const { newBrowserWindow, text, url: urlRef } = payload || {};
    const options = newBrowserWindow === true ? getNewBrowserWindowOptions() : undefined;
    const twitterWindow = window.open('', 'twitter', options);
    const url = `https://twitter.com/intent/tweet?text=${text}&url=${urlRef}&related=1stdibs`;
    if (twitterWindow) {
        twitterWindow.location.href = url;
        listenWindowClose(twitterWindow);
    }
}
